import Login from './Login';

const COMMON ={
    ...Login
}

export default COMMON;